import {Space} from "@src/pages/space";
import {createFileRoute} from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/space")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Space />;
}
